"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import siteConfig from "@/lib/config/site";
import { cn } from "@/lib/utils";

/** Site name/avatar link; needs the current pathname to pick a view transition type. */
const HomeLink = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = pathname === "/" ? undefined : ["nav-lateral"];
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("flex shrink-0 items-center hover:text-foreground/85", "gap-2.5 pr-2 hover:no-underline");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t1) {
    t3 = <Link href="/" rel="author" transitionTypes={t1} aria-label={siteConfig.name} className={t2}>{children}</Link>;
    $[3] = children;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export { HomeLink };